import React from "react";
import HistoryWindow from "../components/historyWindow/historyWindow";
import { useParams } from 'react-router-dom';

export default function HistoryWindowRouter() {
  const { id } = useParams();
  return <HistoryWindow id = {id} />;
}
